export default (filter) => ({
    filter: filter,
    day: null,
    stage: null,
    availableDays: null,
    availableStages: null,
    visibleIds: null,

    init() {
        this.calculateState()
        this.$watch('[day, stage]', () => this.calculateState())
    },

    calculateAvailableDays() {
        return Object.keys(this.filter.days).filter((value) => {
            const idsForThisDay = this.filter.days[value]
            const activeStageIds = this.filter.stages[this.stage]

            if (!this.stage) {
                return idsForThisDay.length > 0
            }

            return idsForThisDay.some((id) => activeStageIds.includes(id))
        })
    },

    calculateAvailableStages() {
        return Object.keys(this.filter.stages).filter((value) => {
            const idsForThisStage = this.filter.stages[value]
            const activeDayIds = this.filter.days[this.day]

            if (!this.day) {
                return idsForThisStage.length > 0
            }

            return idsForThisStage.some((id) => activeDayIds.includes(id))
        })
    },

    calculateVisibleIds() {
        const dayIds = this.day ? this.filter.days[this.day] : null
        const stageIds = this.stage ? this.filter.stages[this.stage] : null

        if (dayIds && stageIds) {
            return dayIds.filter((id) => stageIds.includes(id))
        }

        return dayIds || stageIds || null
    },

    calculateState() {
        this.availableDays = this.calculateAvailableDays()
        this.availableStages = this.calculateAvailableStages()
        this.visibleIds = this.calculateVisibleIds()
    },
})
